import { FC } from "react";
import { FlexBox, MagicBox } from "@brg/ui";
import { BilingLabel, CheckboxRoot } from "../styles";

import { ReactComponent as CheckIcon } from "../../../assets/check.svg";
import { ReactComponent as CheckWhite } from "../../../assets/checkWhite.svg";

type MagicBoxRowPropsT = {
    checked: boolean;
    label?: string;
    style?: any;
    onClick?: (ev: React.SyntheticEvent) => void;
    dark?: boolean;
    isCGrave?: boolean;
  };

const CheckboxField: FC<MagicBoxRowPropsT> = ({ onClick, checked, label, dark, isCGrave }) => (
    <MagicBox
      onClick={onClick}
      pointer
      align="center"
      gx={16}
    >
      <CheckboxRoot checked={checked} isProjectPage>
        {checked && (
          <>
            {(dark && !isCGrave) ? <CheckIcon /> : <CheckWhite />}
          </>
        )}
        <input checked={checked} type="checkbox"/>
      </CheckboxRoot>
      <FlexBox width={'100%'} widthMobile={'100%'}>
        <BilingLabel>
          {label}
        </BilingLabel>
      </FlexBox>
    </MagicBox>
  );

  export default CheckboxField;import { FC } from "react";
import { FlexBox, MagicBox } from "@brg/ui";
import { BilingLabel, CheckboxRoot } from "../styles";

import { ReactComponent as CheckIcon } from "../../../assets/check.svg";
import { ReactComponent as CheckWhite } from "../../../assets/checkWhite.svg";

type MagicBoxRowPropsT = {
    checked: boolean;
    label?: string;
    style?: any;
    onClick?: (ev: React.SyntheticEvent) => void;
    dark?: boolean;
    isCGrave?: boolean;
  };

const CheckboxField: FC<MagicBoxRowPropsT> = ({ onClick, checked, label, dark, isCGrave }) => (
    <MagicBox
      onClick={onClick}
      pointer
      align="center"
      gx={16}
    >
      <CheckboxRoot checked={checked} isProjectPage>
        {checked && (
          <>
            {(dark && !isCGrave) ? <CheckIcon /> : <CheckWhite />}
          </>
        )}
        <input checked={checked} type="checkbox"/>
      </CheckboxRoot>
      <FlexBox width={'100%'} widthMobile={'100%'}>
        <BilingLabel>
          {label}
        </BilingLabel>
      </FlexBox>
    </MagicBox>
  );

  export default CheckboxField;